import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.palette.grayscale.black};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Message = styled.p`
    color: ${({ theme }) => theme.palette.grayscale.white};
    font-size: 1rem;
    text-align: center;
    padding: 1rem;
`;

const GoldcastMessage = ({ message }) => (
    <Wrapper>
        <Message>{message}</Message>
    </Wrapper>
);

GoldcastMessage.propTypes = {
    message: PropTypes.string.isRequired,
};

export default GoldcastMessage;
